import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

const usePathSavedSearch = () => {
  const location = useLocation();

  return useCallback((path) => `${path}${location.search}`, [location]);
};

export default usePathSavedSearch;
